import React, { useContext } from 'react';

import ControlSystemReportContainer, {
  containerConfiguration,
} from '@totem/components/controlSystemReport/ControlSystemReportContainer';
import ReportTable from '@totem/components/controlSystemReport/ReportTable';
import WidgetContext from '@totem/components/customDashboard/home/widgets/WidgetContext';
import InputContainer from '@totem/components/ui_components/reportSettings/InputContainer';
import TableHeadersTop from '@totem/components/ui_components/tables/TableHeadersTop';
import RecordCountBadge from '@totem/components/ui_components/widgets/RecordCountBadge';

const WidgetControlSystemReport = () => {
  const { onSetTitle, componentInstance } = useContext(WidgetContext);
  return (
    <InputContainer
      filterConfig={containerConfiguration}
      defaultSort={{ field: 'name', direction: 'ascend' }}
      componentKey={componentInstance.componentInstanceId}
    >
      <ControlSystemReportContainer
        onRecordTotalChanged={(recordCount: number) =>
          onSetTitle(<RecordCountBadge count={recordCount} />)
        }
      >
        <TableHeadersTop>
          <ReportTable />
        </TableHeadersTop>
      </ControlSystemReportContainer>
    </InputContainer>
  );
};

export default WidgetControlSystemReport;
